/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { Formik, FormikHelpers } from "formik";

import { useHistory } from "react-router-dom";
import { LuCalendarRange, LuListFilter, LuScale, LuUsers } from "react-icons/lu";

import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";

import api from "../../../services/api";

import { useToast } from "../../../hooks/toast";

import {
  DateFilter,
  DateFilterValue,
  Field,
  FilterStyles,
  Section,
} from "../../../components/FilterKit";

interface SearchData {
  proc_reg: string;
  proc_num_pasta: string;
  proc_reg_outros: string;
  // proc_cod_acao: number;
  proc_cod_orgao: number;
  proc_cod_natureza: number;
  proc_orgao_cidade: string;
  proc_orgao_uf: string;
  proc_autor: string;
  proc_reu: string;
  proc_cod_cliente: number;
  proc_cod_adv_resp: number;
  proc_cod_ass_resp: number;
  proc_data_ajuiz_inicio: Date;
  proc_data_ajuiz_final: Date;
  proc_data_ingresso_inicio: Date;
  proc_data_ingresso_final: Date;
  proc_ult_atu_inicio: Date;
  proc_ult_atu_final: Date;
  proc_em_acordo: string;
  updatedin: number;
  nochanges: number;
  formValuesChanged: boolean;
}

const SearchFinancialInformationModIIISelect: React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const initialValues: SearchData = {
    proc_reg: "",
    proc_num_pasta: "",
    proc_reg_outros: "",
    // proc_cod_acao: 0,
    proc_cod_orgao: 0,
    proc_cod_natureza: 0,
    proc_orgao_cidade: "",
    proc_orgao_uf: "",
    proc_autor: "",
    proc_reu: "",
    proc_cod_cliente: 0,
    proc_cod_adv_resp: 0,
    proc_cod_ass_resp: 0,
    proc_data_ajuiz_inicio: new Date(),
    proc_data_ajuiz_final: new Date(),
    proc_data_ingresso_inicio: new Date(),
    proc_data_ingresso_final: new Date(),
    proc_ult_atu_inicio: new Date(),
    proc_ult_atu_final: new Date(),
    proc_em_acordo: "4",
    updatedin: 0,
    nochanges: 0,
    formValuesChanged: false,
  };

  const [lawsuitRegistrationNumber, setLawsuitRegistrationNumber] =
    useState("");
  const [lawsuitFolderNumber, setLawsuitFolderNumber] = useState("");
  const [otherLawsuitNumbers, setOtherLawsuitNumbers] = useState("");
  const [natureSuitsOptions, setNatureSuitsOptions] = useState([{}]);
  const [suitTypesOptions, setSuitTypesOptions] = useState([{}]);
  const [author, setAuthor] = useState("");
  const [defendant, setDefendant] = useState("");
  const [lawsuitId, setLawsuitId] = useState("");
  const [natureId, setNatureId] = useState("");
  const [judgingBodyCityId, setJudgingBodyCityId] = useState("");
  const [judgingBodyStateId, setJudgingBodyStateId] = useState("");
  const [customerId, setCustomerId] = useState("0");
  const [attorneyInChargeId, setAttorneyInChargeId] = useState("");
  const [assistantInChargeId, setAssistantInChargeId] = useState("");
  const [lawsuitStatus, setLawsuitStatus] = useState("4");

  const [updatedInDay, setUpdatedInDay] = useState(0);
  const [noChangesDay, setNoChangesDay] = useState(0);

  const [initialRegistrationDate, setInitialRegistrationDate] = useState<
    string | Date | Date[] | null
  >(null);
  const [finalRegistrationDate, setFinalRegistrationDate] = useState<
    string | Date | Date[] | null
  >(null);
  const [initialEntranceDate, setInitialEntranceDate] = useState<
    string | Date | Date[] | null
  >(null);
  const [finalEntranceDate, setFinalEntranceDate] = useState<
    string | Date | Date[] | null
  >(null);
  const [initialLatestUpdateDate, setInitialLatestUpdateDate] = useState<
    string | Date | Date[] | null
  >(null);
  const [finalLatestUpdateDate, setFinalLatestUpdateDate] = useState<
    string | Date | Date[] | null
  >(null);

  const [attorneysOptions, setAttorneysOptions] = useState([{}]);
  const [assistantsOptions, setAssistantsOptions] = useState([{}]);
  const [customersOptions, setCustomersOptions] = useState([{}]);
  const [dateFilterType, setDateFilterType] = useState("data");
  const [registeredFilterType, setRegisteredFilterType] = useState("data");
  const [latestUpdateFilterType, setLatestUpdateFilterType] = useState("data");

  const handleClear = (resetForm: () => void) => {
    setLawsuitRegistrationNumber("");
    setLawsuitFolderNumber("");
    setOtherLawsuitNumbers("");
    setAuthor("");
    setDefendant("");
    setLawsuitId("");
    setNatureId("");
    setJudgingBodyCityId("");
    setJudgingBodyStateId("");
    setCustomerId("0");
    setAttorneyInChargeId("");
    setAssistantInChargeId("");
    setLawsuitStatus("4");
    setUpdatedInDay(0);
    setNoChangesDay(0);
    setInitialRegistrationDate(null);
    setFinalRegistrationDate(null);
    setInitialEntranceDate(null);
    setFinalEntranceDate(null);
    setInitialLatestUpdateDate(null);
    setFinalLatestUpdateDate(null);
    setDateFilterType("data");
    setRegisteredFilterType("data");
    setLatestUpdateFilterType("data");
    resetForm();
  };

  const validationSchema = null;

  const lawsuitStatusOptions = [
    { name: "ativos", value: "0", style: "font-size: small;" },
    { name: "em acordo", value: "1", style: "font-size: small;" },
    { name: "arquivados", value: "2", style: "font-size: small;" },
    { name: "ativos+em acordo", value: "4", style: "font-size: small;" },
    { name: "todos", value: "5", style: "font-size: small;" },
  ];

  useEffect(() => {
    (async () => {
      await api.get("lawsuits/naturesuits/show/all").then((response) => {
        response.data.map(
          (natureSuit: { natureza_id: number; natureza_descricao: string }) =>
            natureSuitsOptions.push({
              name: natureSuit.natureza_descricao,
              value: natureSuit.natureza_id,
            })
        );
      });
      natureSuitsOptions.splice(0, 1);
      setNatureSuitsOptions(natureSuitsOptions);
    })();
  }, [natureSuitsOptions]);

  useEffect(() => {
    (async () => {
      await api.get("lawsuits/suittypes/show/all").then((response) => {
        response.data.map(
          (natureSuit: { acao_id: number; acao_descricao: string }) =>
            suitTypesOptions.push({
              name: natureSuit.acao_descricao,
              value: natureSuit.acao_id,
            })
        );
      });
      suitTypesOptions.splice(0, 1);
      setSuitTypesOptions(suitTypesOptions);
    })();
  }, [suitTypesOptions]);

  const brazilianStatesOptions = [
    { name: "AC", value: "AC" },
    { name: "AL", value: "AL" },
    { name: "AM", value: "AM" },
    { name: "AP", value: "AP" },
    { name: "BA", value: "BA" },
    { name: "CE", value: "CE" },
    { name: "DF", value: "DF" },
    { name: "ES", value: "ES" },
    { name: "GO", value: "GO" },
    { name: "MA", value: "MA" },
    { name: "MG", value: "MG" },
    { name: "MS", value: "MS" },
    { name: "MT", value: "MT" },
    { name: "PA", value: "PA" },
    { name: "PB", value: "PB" },
    { name: "PE", value: "PE" },
    { name: "PI", value: "PI" },
    { name: "PR", value: "PR" },
    { name: "RJ", value: "RJ" },
    { name: "RN", value: "RN" },
    { name: "RO", value: "RO" },
    { name: "RR", value: "RR" },
    { name: "RS", value: "RS" },
    { name: "SC", value: "SC" },
    { name: "SE", value: "SE" },
    { name: "SP", value: "SP" },
    { name: "TO", value: "TO" },
  ];

  useEffect(() => {
    (async () => {
      await api.get("management/attorneys/show/all").then((response) => {
        response.data.map(
          (attorney: { advogado_id: number; advogado_nome: string }) =>
            attorneysOptions.push({
              name: attorney.advogado_nome,
              value: attorney.advogado_id,
            })
        );
      });
      attorneysOptions.splice(0, 1);
      setAttorneysOptions(attorneysOptions);
    })();
  }, [attorneysOptions]);

  useEffect(() => {
    (async () => {
      await api.get("management/assistants/show/all").then((response) => {
        response.data.map(
          (assistant: {
            administrador_id: number;
            administrador_nome: string;
          }) =>
            assistantsOptions.push({
              name: assistant.administrador_nome,
              value: assistant.administrador_id,
            })
        );
      });
      assistantsOptions.splice(0, 1);
      setAssistantsOptions(assistantsOptions);
    })();
  }, [assistantsOptions]);

  useEffect(() => {
    (async () => {
      await api.get("customers/show/all").then((response) => {
        response.data.map(
          (customer: { cliente_id: number; cliente_nome: string }) =>
            customersOptions.push({
              name: customer.cliente_nome,
              value: customer.cliente_id,
            })
        );
      });
      customersOptions.splice(0, 1);
      setCustomersOptions(customersOptions);
    })();
  }, [customersOptions]);

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>
  ) => {
    try {
      // const access = JSON.parse(sessionStorage.getItem('@Jurisnet:access') || '{}');
      const access = JSON.parse(
        localStorage.getItem("@Jurisnet:access") || "{}"
      );

      let menu = "";
      if (access) {
        menu = access.menu;
      }
      const searchFormData = {
        proc_reg: lawsuitRegistrationNumber,
        proc_num_pasta: lawsuitFolderNumber,
        proc_reg_outros: otherLawsuitNumbers,
        proc_cod_acao: lawsuitId,
        // proc_cod_orgao: judgingBodyId,
        proc_cod_natureza: natureId,
        proc_orgao_cidade: judgingBodyCityId,
        proc_orgao_uf: judgingBodyStateId,
        proc_autor: author,
        proc_reu: defendant,
        proc_cod_cliente: customerId,
        proc_cod_adv_resp: attorneyInChargeId,
        proc_cod_ass_resp: assistantInChargeId,
        dateFilterType,
        registeredFilterType,
        latestUpdateFilterType,
        proc_data_ajuiz_inicio: initialRegistrationDate,
        proc_data_ajuiz_final: finalRegistrationDate,
        proc_data_ingresso_inicio: initialEntranceDate,
        proc_data_ingresso_final: finalEntranceDate,
        proc_ult_atu_inicio: initialLatestUpdateDate,
        proc_ult_atu_final: finalLatestUpdateDate,
        proc_em_acordo: lawsuitStatus,
        updatedin: updatedInDay,
        nochanges: noChangesDay,
        formValuesChanged: false,
        menu,
      };

      history.push({
        pathname: "/report/financialinformationmodIIIselect",
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: "error",
        title: "Ocorreu um problema",
        description: "Tente repetir a pesquisa ou contate o administrador.",
      });
    }
  };

  const toDate = (value: string | Date | Date[] | null) =>
    value instanceof Date ? value : null;

  const registrationFilterValue: DateFilterValue = {
    mode: dateFilterType === "periodo" ? "periodo" : "data",
    start: toDate(initialRegistrationDate),
    end: toDate(finalRegistrationDate),
  };

  const entranceFilterValue: DateFilterValue = {
    mode: registeredFilterType === "periodo" ? "periodo" : "data",
    start: toDate(initialEntranceDate),
    end: toDate(finalEntranceDate),
  };

  const latestUpdateFilterValue: DateFilterValue = {
    mode: latestUpdateFilterType === "periodo" ? "periodo" : "data",
    start: toDate(initialLatestUpdateDate),
    end: toDate(finalLatestUpdateDate),
  };

  // TODO: define set form changed
  return (
    <FilterStyles>
      <Formik
        onSubmit={handleOnSubmit}
        validationSchema={validationSchema}
        enableReinitialize
        initialValues={initialValues}
      >
        {({
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
        }) => (
          <form className="card search-card" onSubmit={handleSubmit}>
            <header className="search-title">
              <h3>
                Relatório de Informações Processuais - Modelo III{" "}
                <small>
                  (Informações financeiras - com seleção de processos)
                </small>
              </h3>
              <span className="search-hint">
                Preencha só o que precisar. Enter pesquisa.
              </span>
            </header>

            <div className="search-grid">
              <div className="search-col">
                <Section icon={<LuScale />} title="Processo">
                  <div className="row r3">
                    <Field id="proc_reg" label="Nº do processo">
                      <InputText
                        id="proc_reg"
                        name="proc_reg"
                        onChange={(e) => {
                          setLawsuitRegistrationNumber(e.target.value);
                          handleChange(e);
                        }}
                        // onBlur={handleBlur}
                        value={lawsuitRegistrationNumber}
                      />
                    </Field>
                    <Field id="proc_num_pasta" label="Pasta nº">
                      <InputText
                        id="proc_num_pasta"
                        name="proc_num_pasta"
                        onChange={(e) => setLawsuitFolderNumber(e.target.value)}
                        onBlur={handleBlur}
                        value={lawsuitFolderNumber}
                      />
                    </Field>
                    <Field id="proc_reg_outros" label="Outros nrs. do processo">
                      <InputText
                        id="proc_reg_outros"
                        name="proc_reg_outros"
                        onChange={(e) => setOtherLawsuitNumbers(e.target.value)}
                        onBlur={handleBlur}
                        value={otherLawsuitNumbers}
                      />
                    </Field>
                  </div>
                  <div className="row r2">
                    <Field id="proc_cod_acao" label="Tipo de ação">
                      <Dropdown
                        id="proc_cod_acao"
                        name="proc_cod_acao"
                        options={suitTypesOptions}
                        onChange={(e) => setLawsuitId(e.target.value)}
                        value={lawsuitId}
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Todas"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    <Field id="proc_cod_natureza" label="Natureza do processo">
                      <Dropdown
                        id="proc_cod_natureza"
                        name="proc_cod_natureza"
                        options={natureSuitsOptions}
                        onChange={(e) => setNatureId(e.target.value)}
                        value={natureId}
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Todas"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    <Field id="proc_orgao_cidade" label="Cidade">
                      <InputText
                        id="proc_orgao_cidade"
                        name="proc_orgao_cidade"
                        onChange={(e) => setJudgingBodyCityId(e.target.value)}
                        value={judgingBodyCityId}
                      />
                    </Field>
                    <Field id="proc_orgao_uf" label="Estado">
                      <Dropdown
                        id="proc_orgao_uf"
                        name="proc_orgao_uf"
                        options={brazilianStatesOptions}
                        onChange={(e) => setJudgingBodyStateId(e.target.value)}
                        value={judgingBodyStateId}
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                  </div>
                </Section>

                <Section icon={<LuUsers />} title="Partes e responsáveis">
                  <div className="row r2">
                    <Field id="proc_autor" label="Autor">
                      <InputText
                        id="proc_autor"
                        name="proc_autor"
                        value={author}
                        onChange={(e) => setAuthor(e.target.value)}
                        autoFocus
                      />
                    </Field>
                    <Field id="proc_reu" label="Réu">
                      <InputText
                        id="proc_reu"
                        name="proc_reu"
                        value={defendant}
                        onChange={(e) => setDefendant(e.target.value)}
                      />
                    </Field>
                    <Field id="proc_cliente" label="Cliente">
                      <Dropdown
                        id="proc_cliente"
                        name="proc_cliente"
                        options={customersOptions}
                        onChange={(e) => setCustomerId(e.target.value)}
                        value={customerId}
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    <Field id="proc_cod_adv_resp" label="Adv. Responsável">
                      <Dropdown
                        id="proc_cod_adv_resp"
                        name="proc_cod_adv_resp"
                        options={attorneysOptions}
                        onChange={(e) => setAttorneyInChargeId(e.target.value)}
                        value={attorneyInChargeId}
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    <Field id="proc_cod_ass_resp" label="Assistente">
                      <Dropdown
                        id="proc_cod_ass_resp"
                        name="proc_cod_ass_resp"
                        options={assistantsOptions}
                        onChange={(e) => setAssistantInChargeId(e.target.value)}
                        value={assistantInChargeId}
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                  </div>
                </Section>
              </div>

              <div className="search-col">
                <Section icon={<LuCalendarRange />} title="Datas">
                  <DateFilter
                    id="ajuizamento"
                    label="Data de ajuizamento"
                    withMode
                    value={registrationFilterValue}
                    onChange={(next) => {
                      if (next.mode !== dateFilterType) {
                        setDateFilterType(next.mode);
                      }
                      setInitialRegistrationDate(next.start);
                      setFinalRegistrationDate(next.end);
                    }}
                  />
                  <DateFilter
                    id="ingresso"
                    label="Ingresso no escritório"
                    withMode
                    value={entranceFilterValue}
                    onChange={(next) => {
                      if (next.mode !== registeredFilterType) {
                        setRegisteredFilterType(next.mode);
                      }
                      setInitialEntranceDate(next.start);
                      setFinalEntranceDate(next.end);
                    }}
                  />
                  <DateFilter
                    id="ultima_atualizacao"
                    label="Data última atualização"
                    withMode
                    value={latestUpdateFilterValue}
                    onChange={(next) => {
                      if (next.mode !== latestUpdateFilterType) {
                        setLatestUpdateFilterType(next.mode);
                      }
                      setInitialLatestUpdateDate(next.start);
                      setFinalLatestUpdateDate(next.end);
                    }}
                  />
                </Section>

                <Section icon={<LuListFilter />} title="Situação">
                  <Field id="proc_em_acordo" label="Incluir processos">
                    <SelectButton
                      id="proc_em_acordo"
                      value={lawsuitStatus}
                      options={lawsuitStatusOptions}
                      optionLabel="name"
                      onChange={(e) => setLawsuitStatus(e.value)}
                    />
                  </Field>
                  <Field
                    id="updatedin"
                    label="Processos sem atualização nos últimos"
                  >
                    <InputNumber
                      id="updatedin"
                      name="updatedin"
                      placeholder="X"
                      value={updatedInDay}
                      onValueChange={(e) => setUpdatedInDay(Number(e.value))}
                      suffix=" dias"
                      min={0}
                    />
                  </Field>
                  <Field
                    id="nochanges"
                    label="Processos sem mov. relevante nos últimos"
                  >
                    <InputNumber
                      id="nochanges"
                      name="nochanges"
                      placeholder="X"
                      value={noChangesDay}
                      onValueChange={(e) => setNoChangesDay(Number(e.value))}
                      suffix=" dias"
                      min={0}
                    />
                  </Field>
                </Section>
              </div>
            </div>

            <footer className="search-actions">
              <div className="buttons">
                <Button
                  icon="pi pi-undo"
                  iconPos="left"
                  label="Limpar campos"
                  className="p-button-outlined p-button-secondary"
                  type="button"
                  onClick={() => handleClear(handleReset)}
                />
                <Button
                  icon="pi pi-check"
                  iconPos="left"
                  label="Pesquisar processos"
                  type="submit"
                  disabled={isSubmitting}
                />
              </div>
            </footer>
          </form>
        )}
      </Formik>
    </FilterStyles>
  );
};

export default SearchFinancialInformationModIIISelect;
